module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.6b3a89a3.ttf";